/**
 * Which modules the SPA may route to: enabled and permitted (`/me`) **and** in this build's
 * `MODULE_PAGES` (ADR-017). A module `/meta` lists but the bundle lacks — an api newer than the
 * web image during a rolling deploy — must never be a redirect target, or `/` would loop.
 */
export function builtModules<T extends string>(
	ids: Iterable<T>,
	built: (id: T) => boolean,
): Set<T> {
	return new Set([...ids].filter(built));
}

/** `/` → `defaultMode`, else the first listed module, among the permitted and built ones. */
export function homeTarget<T extends string>(
	defaultMode: T,
	modules: readonly T[],
	permitted: ReadonlySet<T>,
	built: (id: T) => boolean,
): T | undefined {
	const ok = (id: T) => permitted.has(id) && built(id);
	return ok(defaultMode) ? defaultMode : modules.find(ok);
}
